import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';

// Preset celebration GIFs that admin can choose from
export const CELEBRATION_GIFS = [
  {
    id: 'congrats-1',
    name: 'Congratulations Confetti',
    url: 'https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExeGVoYmt1amU3eWN0N2MxNm45c2licDY4MWNuNGFrY3F6dmdmdDZ6diZlcD12MV9naWZzX3NlYXJjaCZjdD1n/OevPn7vrqSHEcVz1cv/giphy.gif',
    preview: 'https://media.giphy.com/media/OevPn7vrqSHEcVz1cv/giphy.gif'
  },
  {
    id: 'congrats-2', 
    name: 'Celebration Stars',
    url: 'https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExNWt2Z3JmY2UzMHB1bXZsbWVlMDRzcTBqM3c5dzhoazRlbnJzdHpudyZlcD12MV9naWZzX3NlYXJjaCZjdD1n/8VrtCswiLDNnO/giphy.gif',
    preview: 'https://media.giphy.com/media/8VrtCswiLDNnO/giphy.gif'
  },
  {
    id: 'congrats-3',
    name: 'High Five',
    url: 'https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExZzJldWxlN2NqbDBldTM5ZHVxNTlpMHQ0ZzEzdTdqaW9oOWphcnVuZCZlcD12MV9naWZzX3NlYXJjaCZjdD1n/YPTy760meD2xi/giphy.gif',
    preview: 'https://media.giphy.com/media/YPTy760meD2xi/giphy.gif'
  },
  {
    id: 'awesome',
    name: 'You Are Awesome',
    url: 'https://media.giphy.com/media/l0MYt5jPR6QX5pnqM/giphy.gif',
    preview: 'https://media.giphy.com/media/l0MYt5jPR6QX5pnqM/giphy.gif'
  },
  {
    id: 'champion',
    name: 'Champion',
    url: 'https://media.giphy.com/media/3o7abGQa0aRJUurpII/giphy.gif',
    preview: 'https://media.giphy.com/media/3o7abGQa0aRJUurpII/giphy.gif'
  },
  {
    id: 'trophy',
    name: 'Trophy Winner',
    url: 'https://media.giphy.com/media/xUPGcC0R9QjyxkPnS8/giphy.gif',
    preview: 'https://media.giphy.com/media/xUPGcC0R9QjyxkPnS8/giphy.gif'
  },
  {
    id: 'fireworks',
    name: 'Fireworks',
    url: 'https://media.giphy.com/media/26tOZ42Mg6pbTUPHW/giphy.gif',
    preview: 'https://media.giphy.com/media/26tOZ42Mg6pbTUPHW/giphy.gif'
  },
  {
    id: 'dancing',
    name: 'Happy Dance',
    url: 'https://media.giphy.com/media/l0MYGb1LuZ3n7dRnO/giphy.gif',
    preview: 'https://media.giphy.com/media/l0MYGb1LuZ3n7dRnO/giphy.gif'
  }
];

const GifCelebrationModal = ({ 
  isOpen, 
  onClose, 
  gifUrl, 
  badgeName, 
  celebrationMessage,
  autoClose = false // No longer auto-closes by default - user must tap to close
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
    }
  }, [isOpen]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(onClose, 300); // Wait for fade out animation
  };

  if (!isOpen && !isVisible) return null;

  return (
    <div 
      className={`fixed inset-0 z-[9999] flex items-center justify-center transition-opacity duration-300 ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
      onClick={handleClose}
    >
      {/* Backdrop — soft warm charcoal so the white card pops without feeling harsh */}
      <div className="absolute inset-0 bg-stone-900/60 backdrop-blur-sm" />

      {/* Card */}
      <div
        className={`relative z-10 max-w-lg w-full mx-4 bg-white rounded-2xl border border-stone-200 shadow-2xl p-6 sm:p-8 transform transition-all duration-300 ${
          isVisible ? 'scale-100 translate-y-0' : 'scale-95 translate-y-4'
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={handleClose}
          className="absolute top-3 right-3 w-8 h-8 rounded-full flex items-center justify-center text-stone-500 hover:text-stone-900 hover:bg-stone-100 transition-colors"
          aria-label="Close celebration"
        >
          <X size={20} />
        </button>

        {/* Badge Name */}
        {badgeName && (
          <div className="text-center mb-4">
            <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl font-bold text-stone-900">
              🏆 {badgeName}!
            </h2>
          </div>
        )}

        {/* GIF */}
        <div className="rounded-2xl overflow-hidden border border-stone-200 bg-stone-50">
          <img
            src={gifUrl}
            alt="Celebration"
            className="w-full h-auto max-h-[50vh] object-contain"
          />
        </div>

        {/* Celebration Message */}
        {celebrationMessage && (
          <div className="text-center mt-4">
            <p className="text-stone-900 text-lg md:text-xl font-semibold leading-snug">
              {celebrationMessage}
            </p>
          </div>
        )}

        {/* Tap to close hint */}
        <p className="text-center text-stone-500 text-xs sm:text-sm mt-4">
          Tap anywhere to close
        </p>
      </div>
    </div>
  );
};

export default GifCelebrationModal;
